import React from "react";
import { copyToClipboard } from "../utils/copyToClipboard";

const CopyButton = ({ code }) => {
  const handleCopy = async () => {
    const formattedCode = code.replace(/\\n/g, "\n");

    try {
      const message = await copyToClipboard(formattedCode);
      alert(message);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <button
      onClick={handleCopy}
      style={{ marginBottom: "5px", marginRight: "5px" }}
    >
      Copy
    </button>
  );
};

export default CopyButton;
